import React from 'react'
import MaterialTable, { MTableToolbar } from '@material-table/core'
import Button from 'src/components/sharedComponents/CustomButtons/Button'


const ActionsPage = ({ partners }) => {
  const URL_BASE2 =
    process.env.NODE_ENV === 'development'
      ? 'https://gvctest.lucia.com.co/home/follow?'
      : 'https://gvc.lucia.com.co/home/follow?'

  function b64EncodeUnicode(str) {
    return btoa(encodeURIComponent(str))
  }
  const renderActions = (state) => {
    const url = new URL(URL_BASE2)

    const urlParam = {
      tipo: 'jefe',
      idSocio: state.id,
      idEncuestaSocio: state.idEncSocio,
    }

    url.searchParams.append('t', b64EncodeUnicode(JSON.stringify(urlParam)))
    return (
      <Button
          color="tasks"
          onClick={() => window.open(url, '_blank')}
        >
          Acciones
        </Button>
      )
  }

   const renderTotalTasks = (partner) =>
    `${partner.tareasPend}  /  ${partner.tareasVen}  /  ${partner.tareasTiem}  / ${partner.tareasTot}`
  const columns = [
    {
      title: 'Socio',
      field: 'razon_social',
      cellStyle: {
        color: '#2699FB',
      },
    },
    {
      title: 'Acciones: pendientes / vencidas / a tiempo / totales',
      render: (rowData) => renderTotalTasks(rowData),
      cellStyle: {
        textAlign: 'center',
      },
    },
    {
      title: 'Ultima modificación',
      field: 'modificacion'
    },
    {
      title: 'Seguimiento',
      render: (rowData) => renderActions(rowData)
    }

  ]

  return (
    <div>
      <MaterialTable
      style={{
          color: '#5A5A5A',
          fontWeight: 600,
        }}
      title='Acciones de mejora'
      columns={columns}
      data={partners}
      components={{
          Toolbar: (prop) => (
            <div
              style={{
                background: '#FCFCFC',
                color: '#E2A233',
              }}
            >
              <MTableToolbar {...prop} />
            </div>
          ),
        }}
      options={{
        headerStyle: {
            backgroundColor: '#F6F6F6',
            color: '#161615',
            fontSize: '14px',
            fontWeight: 700,
          textAlign: 'center',
        },
      }}
    />
    </div>
  )
}

export default ActionsPage